export function getRmsDocument(item) {
	return item?.user?.document || item?.document;
}

export function getRmsCreatedAt(item) {
	return item?.orderCreatedAt || item?.user?.createdAt || item?.createdAt;
}

export function getRmsReprocessType(item) {
	return item?.user ? 'owner' : 'dependent';
}

export function parseRmsStatus(data) {
	return data?.beneficiario?.status?.toLowerCase() || 'inativo';
}

export function getRmsConsultaPayload(item) {
	const document = getRmsDocument(item);
	const createdAt = getRmsCreatedAt(item);

	if (!document || !createdAt) return null;

	return {
		cpf: document.replace(/\D/g, ''),
		createdAt,
	};
}

export function getRmsReprocessPayload(item) {
	return {
		cpf: getRmsDocument(item),
		type: getRmsReprocessType(item),
	};
}

export function getRmsDisplayName(item) {
	return item?.user?.name || item?.name || 'usuário';
}
